import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_JUSTIFICATIONS_LIST_REQUEST,
  FETCH_JUSTIFICATIONS_LIST_SUCCESS,
  FETCH_JUSTIFICATIONS_LIST_ERROR,
  UPDATE_JUSTIFICATION_REQUEST,
  UPDATE_JUSTIFICATION_SUCCESS,
  UPDATE_JUSTIFICATION_ERROR,
  GET_PAGES,
} from 'actionTypes'

const getPages = (metadata) => ({
  type: GET_PAGES,
  pages: metadata.pageCount,
  current: metadata.page,
  count: metadata.totalCount,
})

/*
 * REQUEST JUSTIFICATIONS
 */
export const fetchJustificationsList =
  (token, page = 1, filter) =>
  (dispatch) => {
    dispatch(fetchJustificationsListRequest())
    const param = {
      page,
      ...filter,
    }

    return new Api(token, dispatch)
      .get(API_URL.LIST_JUSTIFICATIONS, param)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(response.data.pagination))
        dispatch(fetchJustificationsListSuccess(response.data.listPresenter))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchJustificationsListError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchJustificationsListRequest = () => ({
  type: FETCH_JUSTIFICATIONS_LIST_REQUEST,
})

export const fetchJustificationsListSuccess = (data) => ({
  type: FETCH_JUSTIFICATIONS_LIST_SUCCESS,
  payload: data,
})

export const fetchJustificationsListError = (error) => ({
  type: FETCH_JUSTIFICATIONS_LIST_ERROR,
  payload: error,
})

/*
 * SAVE OR UPDATE JUSTIFICATION
 */
export const updateJustification = (token, values, update) => (dispatch) => {
  dispatch(updateJustificationRequest())

  return new Api(token, dispatch)
    .post(`${API_URL.SAVE_JUSTIFICATION}${update ? '' : '-justify'}`, values)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(updateJustificationSuccess(response.data))
      dispatch(hideSpinner())
      return Promise.resolve()
    })
    .catch((error) => {
      dispatch(updateJustificationError(error))
      dispatch(hideSpinner())
      return Promise.reject()
    })
}

export const updateJustificationRequest = () => ({
  type: UPDATE_JUSTIFICATION_REQUEST,
})

export const updateJustificationSuccess = (data) => ({
  type: UPDATE_JUSTIFICATION_SUCCESS,
  payload: data,
})

export const updateJustificationError = (error) => ({
  type: UPDATE_JUSTIFICATION_ERROR,
  payload: error,
})

/*
 * REMOVE JUSTIFICATION
 */
export const removeJustification = (token, id) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.REMOVE_JUSTIFICATION, id)
    .then(dispatch(showSpinner()))
    .then(() => {
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(updateJustificationError(error))
      dispatch(hideSpinner())
    })
